/** @format */

import React from "react";
import Mojeed from "../assets/images/Background.png";

const Main = () => {
	return (
		<>
			<div className="row pt hidden">
				<div className="col-lg-5">
					<h1 className="hero">Adio Mojeed,</h1>
					<h4>Frontend Web Developer And Technical Article Writer</h4>
					<h6>JavaScript | ReactJS | Firebase | Sass | Bootstrap</h6>
					<h1 className="hero-link">
						<a href="https://github.com/Adiomojeed">
							<i className="fab fa-github"></i>
						</a>
						<a href="https://linkedin.com/in/adiomojeed">
							<i className="fab fa-linkedin"></i>
						</a>

						<a href="https://twitter.com/adio_mojeed">
							<i className="fab fa-twitter"></i>
						</a>
					</h1>
				</div>
				<div className="col-lg-7">
					<div className="circle">
						<i className="far fa-circle"></i>
						<i className="far fa-circle"></i>
						<i className="far fa-circle"></i>
					</div>

					<img src={Mojeed} alt="" className="image-fluid" />
				</div>
			</div>
		</>
	);
};

export default Main;
